<template>
  <div v-if="formData">
    <v-layout wrap row>
      <v-flex xs5>
        <content-field
          v-model="formData.title"
          label="Title"
          :error="$v.formData.title"
        />
      </v-flex>
    </v-layout>
    <!--<v-layout wrap row>-->
      <!--<v-flex xs5>-->
        <!--<content-editor-->
          <!--v-model="formData.metaDescription"-->
          <!--placeholder="Meta description"-->
          <!--:error="$v.formData.metaDescription"-->
        <!--/>-->
      <!--</v-flex>-->
    <!--</v-layout>-->
    <v-layout wrap row>
      <v-flex xs5>
        <content-editor
          v-model="formData.topText"
          placeholder="Top text"
          :error="$v.formData.topText"
        />
      </v-flex>
    </v-layout>
    <!--<v-layout wrap row>-->
      <!--<v-flex xs5>-->
        <!--<content-field-->
          <!--v-model="formData.counterText"-->
          <!--label="Counter text"-->
          <!--:error="$v.formData.counterText"-->
        <!--/>-->
      <!--</v-flex>-->
    <!--</v-layout>-->
    Counter time:
    <v-layout row>
      <v-date-picker
        v-model="counter.date"
        show-current="false"
      />
      <v-time-picker
        v-model="counter.time"
        format="24hr"
      />
    </v-layout>
    <v-layout wrap row mt-2>
      <v-flex xs5 d-flex justify-center>
        {{counterTimeStamp}}
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5 d-flex justify-center>
        <span v-if="isCounterError" class="text-xs-center red--text">Counter time or date not valid</span>
      </v-flex>
    </v-layout>
    <v-layout mt-4>
      <v-flex xs5>
        <v-card>
          <div class="grey lighten-2">
            <v-card-media height="130" :src="formData.banner"/>
          </div>
          <v-card-title><h3>Banner</h3></v-card-title>
          <v-card-actions>
            <v-btn
              flat
              color="success"
              @click="openGallery">Choose</v-btn>
            <v-btn
              flat
              color="error"
              @click="resetBanner">Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <content-field
          v-model="formData.link"
          label="Link"
          :error="$v.formData.link"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <content-field
          v-model="formData.companyVotesNumberPerCategory"
          label="Company votes number per category"
          type="number"
          :error="$v.formData.companyVotesNumberPerCategory"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <content-editor
          v-model="formData.userAlreadyVoteMessage"
          label="Already voted message"
          :error="$v.formData.userAlreadyVoteMessage"
        />
      </v-flex>
    </v-layout>
    <v-layout class="mt-4" wrap row>
      <v-flex xs5>
        <h2>Button settings:</h2>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <content-field
          v-model="formData.submitButtonSettings.text"
          label="Button text"
          :error="$v.formData.submitButtonSettings.text"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <content-field
          v-model="formData.submitButtonSettings.fontFamily"
          label="Font family"
          :error="$v.formData.submitButtonSettings.fontFamily"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs2>
        <content-field
          v-model="formData.submitButtonSettings.fontSize"
          label="Font size"
          type="number"
          :error="$v.formData.submitButtonSettings.fontSize"
        />
      </v-flex>
      <v-flex xs2 offset-xs1>
        <v-select
          :items="fontWights"
          v-model="formData.submitButtonSettings.fontWeight"
          label="Font weight"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <e-color-picker
          label="Font color"
          :value="getColorObject(formData.submitButtonSettings.fontColor)"
          @colorChange="setColor($event, 'fontColor')"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <e-color-picker
          label="Active background color"
          :value="getColorObject(formData.submitButtonSettings.activeBackgroundColor)"
          @colorChange="setColor($event, 'activeBackgroundColor')"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <e-color-picker
          label="Active hover background color"
          :value="getColorObject(formData.submitButtonSettings.activeHoverBackgroundColor)"
          @colorChange="setColor($event, 'activeHoverBackgroundColor')"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex xs5>
        <e-color-picker
          label="Offline background color"
          :value="getColorObject(formData.submitButtonSettings.offlineBackgroundColor)"
          @colorChange="setColor($event, 'offlineBackgroundColor')"
        />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-btn class="green white--text" @click="submitUpdate">Update</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isGalleryVisible">
      <galleries-list :modalView="true" @pickedImage="setBanner"/>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { path } from 'ramda'
import { required, url, numeric, minValue } from 'vuelidate/lib/validators'
import ContentField from '@/components/shared/ContentField'
import ContentEditor from '@/components/shared/ContentEditor'
import EColorPicker from '@/components/shared/EColorPicker'
import GalleriesList from '@/components/pages/Gallery/GalleriesList'
import moment from 'moment'

// function which prepends zero to number if it's length less than 2. Example: 6 => '06'
const pad = number => number.toString().length < 2 ? `0${number}` : number

export default {
  name: 'AwardsSettingsStepTwo',
  components: {
    ContentField,
    ContentEditor,
    EColorPicker,
    GalleriesList
  },
  data () {
    return {
      formData: null,
      counter: {
        date: null,
        time: null
      },
      isGalleryVisible: false,
      isLoaded: false,
      fontWights: [300, 400, 500, 600, 700, 800, 900]
    }
  },
  validations: {
    formData: {
      title: { required },
      // metaDescription: { required },
      topText: { required },
      // counterText: { required },
      counterTime: {
        required,
        greaterThanToday(value) {
          const today = new Date().setHours(0,0,0,0)
          const selectedDate = new Date(value).setHours(0,0,0,0)
          return selectedDate > today
        }
      },
      banner: { url },
      link: { url },
      companyVotesNumberPerCategory: { required, numeric, minValue: minValue(1) },
      userAlreadyVoteMessage: { required },
      submitButtonSettings: {
        text: { required },
        fontFamily: { required },
        fontSize: { required, numeric },
        fontWeight: { required },
        fontColor: { required },
        activeBackgroundColor: { required },
        activeHoverBackgroundColor: { required },
        offlineBackgroundColor: { required }
      }
    }
  },
  computed: {
    ...mapGetters(['getSettings']),
    isCounterError () {
      return this.$v.formData.$dirty && this.$v.formData.counterTime.$invalid
    },
    counterTimeStamp () {
      return `${this.counter.date} ${this.counter.time}`
    }
  },
  methods: {
    ...mapActions({
      fetchSettings: 'fetchGeneralSettings',
      updateSettings: 'putAwardsStepTwoSettings'
    }),
    getColorObject (hex) {
      return { hex }
    },
    setBanner (image) {
      this.formData.banner = image.imagesUrls.originalImageUrl
      this.isGalleryVisible = false
    },
    openGallery () {
      this.isGalleryVisible = true
    },
    resetBanner () {
      this.formData.banner = ''
    },
    setColor (color, key) {
      this.formData.submitButtonSettings[key] = color.hex
    },
    submitUpdate () {
      this.$v.$touch()
      this.formData.counterTime = moment(`${this.counter.date} ${this.counter.time}`)
      // Todo need to fix naming in BE
      this.formData.submitButtonSetting = this.formData.submitButtonSettings
      if (this.$v.formData.$invalid) return
      this.formData.metaDescription = 'none'
      this.updateSettings(this.formData)
    }
  },
  async mounted () {
    if (!this.getSettings) {
      await this.fetchSettings()
    }
    this.formData = path(['awardsStepTwoPageSetting'], this.getSettings)
    const counterDate = new Date(this.formData.counterTime)
    this.counter.date = `${counterDate.getFullYear()}-${pad(counterDate.getMonth() + 1)}-${pad(counterDate.getUTCDate())}`
    this.counter.time = `${pad(counterDate.getHours())}:${pad(counterDate.getMinutes())}`
  }
}
</script>

<style lang="scss" scoped>
/deep/ .date-picker-title {
  height: 70px;
}

/deep/ .date-picker-header {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Awards/Settings/StepTwo/index.vue